import React from "react";
import { isEmpty } from "lodash";
import Paper from "@mui/material/Paper";
import { Grid } from "@material-ui/core";
import ClipLoader from "react-spinners/ClipLoader";
// component
import { MyCheckbox } from "components";
import Stripe from "components/StripeCard/Stripe";
import { numberFormat } from "helper/numberFormat";
import { InputField } from "components/InputField/InputField";
import RadioButtons from "components/RadioButtons/RadioButtons";
// directly import
import AchCardList from "./AchCardList";
import CreditCardList from "./CreditCardList";
import RecaptchaPayment from "./RecaptchaPayment";
import { PaymentButton, PaymentCardTitle, PaymentCardWrapper } from "./Theme";
import { Fonts } from "theme/fontConfig";
export const PaymentCard = ({
  TotalForPay,
  formik,
  isLoadingPay,
  totalPay,
  setLoadingPay,
  isStripe,
  addCardStripeRef,
  isAuthenticated,
  setSelectedCard,
  selectedCard,
  recaptchaRef,
  setSelectedAchCard,
  selectedAchCard,
  enableAchPay,
  enableCreditCardPay,
  disabledCreditCardPay,
  displayAchTooltip,
  publicKey,
  enableBillMyAccount,
  finantialAid,
  donationError,
}) => {
  const billMyAccount = formik?.values?.activePayment === "bill-my-account";
  const cardList = formik?.values?.listCards?.data ?? [];
  const achList = formik?.values?.listAch?.data ?? [];

  const handleExpiryChange = (text) => {
    formik.setFieldValue("cardsDetails.expiry", text);
    if (text.length > 2) {
      if (text[2] !== "/") {
        formik.setFieldValue(
          "cardsDetails.expiry",
          text.substring(0, 2) + "/" + text.substring(2, 4)
        );
      }
    }
  };

  const paymentTabs = [
    ...(enableCreditCardPay
      ? [
          {
            label: "Pay with credit card",
            value: "credit-card",
            disabled: disabledCreditCardPay || finantialAid,
          },
        ]
      : []),
    ...(enableAchPay && !isEmpty(achList)
      ? [
          {
            label: "Pay with ACH",
            value: "ach",
            disabled: isEmpty(achList) || finantialAid,
            showTooltip: displayAchTooltip,
            tooltip: displayAchTooltip,
            tooltipPlacement: "top",
          },
        ]
      : []),
    ...(enableBillMyAccount
      ? [
          {
            label: "Bill my account",
            value: "bill-my-account",
          },
        ]
      : []),
  ];

  return (
    <>
      <Paper
        sx={{
          minHeight: "278px",
          marginTop: "33px",
          borderRadius: "10px",
          backgroundColor: (theme) =>
            theme.palette.mode === "dark" ? "#1A2027" : "#fff",
        }}
      >
        <PaymentCardWrapper>
          <PaymentCardTitle>
            <span className="title_address_details">Payment</span>
          </PaymentCardTitle>

          <Grid
            container
            spacing={3}
            style={{
              minHeight: "230px",
            }}
          >
            {paymentTabs?.length > 1 && (
              <Grid
                item
                xs={12}
                style={{
                  marginBottom: "-15px",
                }}
              >
                <RadioButtons
                  value={formik?.values?.activePayment}
                  name={"activePayment"}
                  row={true}
                  onChange={(value) => {
                    formik.setFieldValue("activePayment", value);
                    if (value === "bill-my-account") {
                      formik.setFieldValue("billMyAccount", true);
                      formik.setFieldValue("finantialAid", false);
                      setSelectedCard(null);
                      setSelectedAchCard(null);
                    } else if (value === "ach") {
                      formik.setFieldValue("billMyAccount", false);
                      const achSelected = achList?.find((el) => el?.is_default)
                        ?.id;
                      const achConfirmed = achSelected ?? achList?.[0]?.id;
                      setSelectedAchCard(achConfirmed);
                      setSelectedCard(null);
                    } else {
                      formik.setFieldValue("billMyAccount", false);
                      const cardSelected = cardList?.find(
                        (el) => el?.is_default
                      )?.id;
                      const cardConfirmed = cardSelected ?? cardList?.[0]?.id;
                      setSelectedCard(cardConfirmed);
                      setSelectedAchCard(null);
                    }
                  }}
                  size={"small"}
                  options={paymentTabs}
                />
              </Grid>
            )}
            {formik?.values?.activePayment === "credit-card" ? (
              <>
                {!isEmpty(cardList) ? (
                  <Grid item xs={12} className="d-flex align-items-center">
                    <CreditCardList
                      isStripe={isStripe}
                      setSelectedCard={setSelectedCard}
                      selectedCard={selectedCard}
                      publicKey={publicKey}
                      cardList={cardList}
                      isSelectedList={isEmpty(formik?.values?.selectedCard)}
                      formik={formik}
                      addCardStripeRef={addCardStripeRef}
                    />
                  </Grid>
                ) : isStripe ? (
                  <Grid item xs={12}>
                    <Stripe
                      loading={isLoadingPay}
                      setLoading={setLoadingPay}
                      saveCard={false}
                      ref={addCardStripeRef}
                      publicKey={publicKey}
                    />
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <MyCheckbox
                        value={formik?.values?.saveCard}
                        name={"saveCard"}
                        row={true}
                        handlechange={(e) => {
                          formik.setFieldValue("saveCard", e?.target?.checked);
                        }}
                        size={"small"}
                        title="Save card"
                      />
                    </div>
                  </Grid>
                ) : (
                  <>
                    <Grid item xs={12} sm={12} md={6}>
                      <InputField
                        placeholder="XXXX XXXX XXXX XXXX"
                        label="Card Number"
                        isRequired={true}
                        styleWrapper={{ width: "100%" }}
                        style={{
                          width: "100%",
                          background:
                            TotalForPay === 0 && "var(--Gray-10, #F8F8F9)",
                        }}
                        isOptional={false}
                        labelStyle={{
                          color:
                            TotalForPay === 0
                              ? "var(--Gray-100, #B5B5C3)"
                              : "var(--Dark-Blue-100, #002E5C)",
                          ...Fonts.GeneralLabelFont,
                        }}
                        value={formik.values?.cardsDetails.card_number}
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        handleChange={(e) => {
                          formik.setFieldValue(
                            "cardsDetails.card_number",
                            e?.target?.value
                          );
                        }}
                        minLength="16"
                        maxLength="16"
                        isGray={TotalForPay === 0}
                      />
                    </Grid>
                    <Grid item xs={6} sm={6} md={3}>
                      <InputField
                        placeholder="MM/YY"
                        label="Expire Date"
                        isRequired={true}
                        styleWrapper={{ width: "100%" }}
                        style={{
                          width: "100%",
                          background:
                            TotalForPay === 0 && "var(--Gray-10, #F8F8F9)",
                        }}
                        isOptional={false}
                        labelStyle={{
                          color:
                            TotalForPay === 0
                              ? "var(--Gray-100, #B5B5C3)"
                              : "var(--Dark-Blue-100, #002E5C)",
                          ...Fonts.GeneralLabelFont,
                        }}
                        isGray={TotalForPay === 0}
                        value={formik.values?.cardsDetails.expiry}
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        handleChange={(e) =>
                          handleExpiryChange(e?.target?.value)
                        }
                      />
                    </Grid>
                    <Grid item xs={6} sm={6} md={3}>
                      <InputField
                        placeholder="3-4 digits"
                        label="CVC"
                        isRequired={true}
                        minLength="4"
                        maxLength="4"
                        styleWrapper={{ width: "100%" }}
                        style={{
                          width: "100%",
                          background:
                            TotalForPay === 0 && "var(--Gray-10, #F8F8F9)",
                        }}
                        isOptional={false}
                        labelStyle={{
                          color:
                            TotalForPay === 0
                              ? "var(--Gray-100, #B5B5C3)"
                              : "var(--Dark-Blue-100, #002E5C)",
                          ...Fonts.GeneralLabelFont,
                        }}
                        value={formik.values?.cardsDetails.cvc}
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        handleChange={(e) => {
                          formik.setFieldValue(
                            "cardsDetails.cvc",
                            e?.target?.value
                          );
                        }}
                        isGray={TotalForPay === 0}
                      />
                    </Grid>
                    <Grid item xs={12} className="d-flex align-items-center">
                      <MyCheckbox
                        value={formik?.values?.saveCard}
                        name={"saveCard"}
                        row={true}
                        handlechange={(e) => {
                          formik.setFieldValue("saveCard", e?.target?.checked);
                        }}
                        size={"small"}
                        title="Save card"
                      />
                    </Grid>
                  </>
                )}
              </>
            ) : formik?.values?.activePayment === "ach" ? (
              <Grid item xs={12} className="d-flex align-items-center">
                <AchCardList
                  setSelectedAchCard={setSelectedAchCard}
                  selectedAchCard={selectedAchCard}
                  cardList={achList}
                />
              </Grid>
            ) : null}
            <Grid item xs={12} className="d-flex align-items-center">
              <RecaptchaPayment recaptchaRef={recaptchaRef} formik={formik} />
            </Grid>

            <Grid item xs={12} className="d-flex align-items-end">
              <PaymentButton>
                <button
                  onClick={formik.handleSubmit}
                  type="button"
                  disabled={
                    !(formik.isValid && formik.dirty) || formik.isSubmitting || donationError
                  }
                  style={{
                    opacity:
                      !(formik.isValid && formik.dirty) || formik.isSubmitting || donationError
                        ? 0.5
                        : 1,
                  }}
                >
                  {formik.isSubmitting ? (
                    <ClipLoader
                      color={"#ffffff"}
                      loading={formik.isSubmitting}
                      size={32}
                      s
                      aria-label="Loading Spinner"
                      data-testid="loader"
                    />
                  ) : totalPay?.finalAmount > 0 ? (
                    formik?.values?.activePayment !== "bill-my-account" ? (
                      `PAY ${numberFormat({
                        number: totalPay?.finalAmount,
                        decimal: 2,
                        style: "currency",
                      })}`
                    ) : (
                      "BILL MY ACCOUNT"
                    )
                  ) : (
                    "PAY"
                  )}
                </button>
              </PaymentButton>
            </Grid>
          </Grid>
        </PaymentCardWrapper>
      </Paper>
    </>
  );
};
